export default __webpack_public_path__ + "static/media/ComingSoon.afc7b7d6.svg";